import { render } from "./HelpBookingWellnessDialog.vue?vue&type=template&id=80ddf322"
import script from "./HelpBookingWellnessDialog.vue?vue&type=script&lang=js"
export * from "./HelpBookingWellnessDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__